import { CheckboxFieldDE } from "../common/CheckboxFieldDE";

export type BooleanFields<T> = {
  [K in keyof T]: T[K] extends boolean | null ? K : never;
}[keyof T];

type ProcessDataCheckboxField<T> = {
  value: boolean | null | undefined;
  field: BooleanFields<T>;
  label?: string;
  disabled?: boolean;
  onChange?: (checked: boolean) => void;
};

export const ProcessDataCheckboxFieldDE = <T,>({
  value,
  field,
  label,
  disabled = false,
  onChange = () => {},
}: ProcessDataCheckboxField<T>) => {
  return (
    <CheckboxFieldDE
      label={label || String(field)}
      value={value || false}
      disabled={disabled}
      onChange={(e) => onChange(e.target.checked)}
    />
  );
};
